import React from 'react';
import '../../../../../Stylesheets/Dashboard/DeleteProjectModal.css';

const DeleteProjectModal = ({ onCancel, onConfirm }) => {
  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-box">
        <h3>Delete Project?</h3>
        <p>This action cannot be undone. Are you sure you want to proceed?</p>
        <div className="delete-modal-actions">
          <button className="cancel-btn-delete" onClick={onCancel}>Cancel</button>
          <button className="confirm-btn-delete" onClick={onConfirm}>Yes, Delete</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteProjectModal;
